import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

export const showConfirmDialog = ({
  title,
  message,
  onConfirm,
  type = "default",
  btn,
}) => {
  const bgMap = {
    default: "bg-white/20 border-white/30 text-white",
    danger: "bg-[#f8d7da]/30 border-[#721c24] text-[#721c24]",
    success: "bg-[#d4edda]/30 border-[#155724] text-[#155724]",
    warning: "bg-[#fff3cd]/30 border-[#856404] text-[#856404]",
    info: "bg-[#d1ecf1]/20 border-[#0c5460] text-[#0c5460]",
  };

  const bgClass = bgMap[type] || bgMap.default;
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <div className="fixed inset-0 bg-black bg-opacity-10 backdrop-blur-sm flex items-center justify-center z-[200]">
          <div
            className={`backdrop-blur-lg border rounded-2xl shadow-xl p-3 w-80  animate-fade-in ${bgClass}`}
          >
            <div className=" flex gap-2 flex-col mb-2">
              <h1 className="text-2xl font-bold ">{title || "Confirm"}</h1>
              <p className="">
                {message || "Are you sure you want to continue?"}
              </p>
            </div>
            <div className="flex justify-end items-center gap-4 text-sm font-semibold">
              <button
                className={`px-3 py-1  rounded ${bgClass} animate-fade-in`}
                onClick={() => {
                  onConfirm();
                  onClose();
                }}
              >
                {btn ? btn : "Confirm"}
              </button>
              <button
                className={`px-3 py-1  rounded ${bgClass} animate-fade-in`}
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      );
    },
  });
};
